import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

import { DynamicDialogConfig, DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';

import { HelperService, HTTPService, DateService } from 'app/services';
import { datetimeFormat } from 'app/constants/date-time-format';
import { currency } from 'app/constants/currency.constants';

@Component({
  selector: 'ngx-core-and-tire-return-dialog',
  templateUrl: './core-and-tire-return-dialog.component.html',
  styleUrls: ['./core-and-tire-return-dialog.component.scss'],
  providers: [DialogService],
})
export class CoreAndTireReturnDialogComponent implements OnInit {
  @ViewChild('startDateCalendarContainer')
  startDateCalendarContainer: ElementRef;

  isProcessing: boolean = false;
  errors: any = {};
  focus: any = {};
  item: any = {};
  isSaving: boolean = false;
  usd: string = currency.USD;
  data: any = {};
  coreRetrievalStatus: any[] = [
    { value: 'toBeRetrieved', label: 'To be retrieved', statusActive: true },
    { value: 'damaged', label: 'Damaged', statusActive: true },
    { value: 'retrieved', label: 'Retrieved', statusActive: true },
  ];
  constructor(
    private dateService: DateService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    public helperService: HelperService,
    private httpService: HTTPService
  ) {}

  ngOnInit() {
    this.data = this.dynamicDialogConfig.data || {};

    if (this.data && this.data.returnType === 'item') {
      this.focus.itemReturnQty = true;
    } else {
      this.focus.coreCost = true;
    }

    this.getAdHocItem(this.data._id);
  }

  async getAdHocItem(partId: any) {
    try {
      let item = null;

      if (this.data.itemSource === 'PartsTech') {
        const { orderId, orderItemId } = this.data;
        item = await this.httpService.getAdHocPartById(partId, { orderId, orderItemId });
      } else if (partId) {
        item = await this.httpService.getAdHocPartById(partId);
      }

      if (item) {
        this.data.qtyOrdered = item.qtyOrdered || '';
        this.data.supplierInvoiceNo = item.supplierInvoiceNo;
        this.data.itemReturnQty = item.itemReturnQty || '';
        this.data.coreCost = item.coreCost || '';

        if (item.itemReturnDate) {
          this.data.returnDate = this.dateService.getCurrentDateTimeTz(new Date(item.itemReturnDate).getTime());
        }
      }

      this.data.qtyOrdered = this.data.qtyOrdered || '';
      this.data.itemReturnQty = this.data.itemReturnQty || '';
      this.data.coreCost = this.data.coreCost || '';

      if (!['PartsTech', 'Nexpart'].includes(this.data.itemSource) && !this.data.qtyOrdered) {
        this.data.qtyOrdered = this.data.count;
      }

      if (this.data.returnType === 'item' && !this.data.qtyOrdered) {
        this.data.qtyOrdered = this.data.count;
      }

      if (!this.data.returnDate) {
        const serverTime: any = await this.httpService.getServerTime();
        this.data.returnDate = this.dateService.getCurrentDateTimeTz(serverTime);
      }

      this.setItemDetails(this.data);
    } catch (err) {
      this.helperService.showToaster('error', err);
    }
  }

  setItemDetails(data: any) {
    this.item = data;
    this.item.totalCost = data.cost * data.count;

    if (this.item.itemSource === 'PartsTech') {
      this.item.qtyOrdered = data.count || 0;
    }
  }

  handleChange(key: string, value: any) {
    this.item[key] = value;
  }

  handleFocus(key: string) {
    this.errors[key] = '';
    this.focus[key] = true;
  }

  handleBlur(key: string) {
    this.focus[key] = false;

    if (['itemReturnQty', 'qtyOrdered'].includes(key)) {
      if (Number(this.item.itemReturnQty) > Number(this.item.qtyOrdered)) {
        this.errors.itemReturnQty = 'Quantity returned can not be greater than quantity ordered';
      } else {
        this.errors.itemReturnQty = '';
      }
    }

    if (['coreCost', 'cost'].includes(key)) {
      if (Number(this.item.coreCost) > Number(this.item.cost)) {
        this.errors.coreCost = 'Core cost can not be greater than item cost.';
      } else {
        this.errors.coreCost = '';
      }
    }
  }

  handleClose(isSuccess: boolean = false, data: any = {}) {
    this.dynamicDialogRef.close({ data, isSuccess });
  }

  isValid() {
    let isValid = true;

    if (Number(this.item.itemReturnQty) > Number(this.item.qtyOrdered)) {
      isValid = false;
      this.errors.itemReturnQty = 'Quantity returned can not be greater than quantity ordered';
    }

    if (Number(this.item.coreCost) > Number(this.item.cost)) {
      isValid = false;
      this.errors.coreCost = 'Core cost can not be greater than item cost.';
    }

    return isValid;
  }

  handleSave() {
    if (!this.isValid()) {
      return;
    }

    const item = { ...this.item, orderServiceItemId: this.item._id };

    if (item.coreCost) {
      item.totalCoreCost = Number(item.coreCost) * Number(item.count);

      if (item.coreRetrievalStatus) {
        item.coreRetrievalStatus = item.coreRetrievalStatus.value;
      }
    } else {
      item.coreRetrievalStatus = '';
    }

    if (item.itemReturnQty) {
      if (item.returnDate) {
        item.itemReturnDate = this.dateService.formatDate(item.returnDate, datetimeFormat.yyymmdd);
      }
    } else {
      item.itemReturnDate = null;
    }

    this.isSaving = true;
    this.httpService
      .addUpdateReturn(item._id, item)
      .then(
        (res) => {
          this.handleClose(true, res);
          this.helperService.showToaster('success', 'Successfully saved');
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isSaving = false;
      });
  }
}
